import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AnnouncerService {
  constructor() { }

  private speechQueue: { text: string; language: string }[] = [];
  private isSpeaking: boolean = false;

  async enqueueSpeech(text: string, targetLanguage: string = 'en-US') {
    console.log("Original Text: ", text, "Target Language: ", targetLanguage);
    
    const translatedText = await this.translateText(text, targetLanguage);
    
    console.log("Translated Text: ", translatedText);
    this.speechQueue.push({ text: translatedText, language: targetLanguage });

    if (!this.isSpeaking) {
      this.processQueue();
    }
  }

  processQueue() {
    if (this.speechQueue.length === 0) {
      this.isSpeaking = false;
      return;
    }

    this.isSpeaking = true;
    const { text, language } = this.speechQueue.shift()!;

    this.speakText(text, language, () => {
      this.processQueue();
    });
  }

  speakText(text: string, language: string, onComplete: () => void, pauseDuration: number = 500) {
    try {
      if (!window.speechSynthesis) {
        throw new Error('Speech Synthesis not supported in this browser.');
      }

      console.log("Speaking: ", text, "Language: ", language);
      const bellSound = new Audio('assets/sound/announcement-bell.mp3');

      bellSound.play().then(() => {
        setTimeout(() => {
          const sentences = text.split('. ');
          let index = 0;

          const loadVoices = () => {
            return new Promise<SpeechSynthesisVoice[]>((resolve) => {
              let voices = window.speechSynthesis.getVoices();
              if (voices.length) {
                resolve(voices);
              } else {
                window.speechSynthesis.onvoiceschanged = () => {
                  resolve(window.speechSynthesis.getVoices());
                };
              }
            });
          };

          loadVoices().then(voices => {
            const specificVoice = voices.find(voice => voice.lang === language);
            const femaleVoice = voices.find(voice => voice.name.includes('Google') && voice.name.includes('Female')) 
                              || voices.find((voice: any) => voice.gender === 'female') 
                              || voices[0];

            const selectedVoice = specificVoice || femaleVoice;

            const speakNextSentence = () => {
              try {
                if (index < sentences.length) {
                  const speech = new SpeechSynthesisUtterance(sentences[index]);
                  speech.lang = language;
                  speech.voice = selectedVoice;
                  speech.rate = 1;
                  speech.pitch = 1.5;
                  speech.volume = 1;

                  speech.onend = () => {
                    index++;
                    if (index < sentences.length) {
                      setTimeout(speakNextSentence, pauseDuration);
                    } else {
                      onComplete();
                    }
                  };

                  window.speechSynthesis.speak(speech);
                }
              } catch (err) {
                console.error('Error while speaking:', err);
                onComplete();
              }
            };

            speakNextSentence();
          });
        }, 500);
      }).catch(error => {
        console.error('Error playing bell sound:', error);
        onComplete();
      });

    } catch (error) {
      console.error('Speech Synthesis Error:', error);
      alert('Speech Synthesis is not supported in your browser or an error occurred.');
      onComplete();
    }
  }

  async translateText(text: string, targetLanguage: string): Promise<string> {
    try {
      const response = await fetch(`https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=en|${targetLanguage}`);
      const data = await response.json();
      return data.responseData.translatedText || text;
    } catch (error) {
      console.error('Translation Error:', error);
      return text;
    }
  }
}